import { CompetitionUpdate } from '@vote4dance/judging-schema';
import { ClassId, CompetitionId, TeamId, UserId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";
import { UserItem } from './users';

export type FavoriteType = 'team' | 'competition' | 'organization';

export interface FavoriteItem {
    favorite_id: string;
    favorite_type: FavoriteType;
    favorite_lookup: TeamId | CompetitionId;
    favorite_name: string;
    competition_id?: CompetitionId;
    class_id?: ClassId | null;
}

export interface NotificationTokenItem {
    token_value: string;
    push_provider: string;
    token_platform?: string | null;
    app_identifier?: string | null;
    last_seen_at?: string | null;
}

export function CompetitionUpdateSource(event_id: CompetitionId) {
    return new StreamSource<CompetitionUpdate[]>(`/competition-updates/${event_id}`);
}

export function CompetitionFollowSource(user_id: UserId, competition_id: CompetitionId) {
    return new StreamSource<UserItem[]>(`/competition-follow/${user_id}/${competition_id}`);
}

export function CompetitionFollowerSource(competition_id: CompetitionId) {
    return new StreamSource<UserItem[]>(`/competition-followers/${competition_id}`);
}

export function FavoriteSource(user_id: UserId) {
    return new StreamSource<FavoriteItem[]>(`/favorites/${user_id}`);
}

export function NotificationTokenSource(user_id: UserId) {
    return new StreamSource<NotificationTokenItem[]>(`/notification_token/${user_id}`);
}
